//
// Copyright 2020 The MathWorks, Inc
//
// DO NOT MODIFY THIS FILE!!  This is a derived file.
// Instead, modify the English message catalog XML file "resources/RTW/en/buildStatus.xml"
// Encoding: UTF-8
//

define({
    Actions: "アクション",
    AutoOpenChk: "ビルド中に自動で開く",
    Blocked: "ブロック済み",
    BuildStatus: "ビルド ステータス",
    Building: "ビルド中",
    CancelBuildAct: "ビルドのキャンセル",
    Canceled: "キャンセル済み",
    Canceling: "キャンセル中",
    CodeGenTargets: "コード生成ターゲット",
    Completed: "完了",
    ElapsedTime: "経過時間",
    Error: "エラー",
    Help: "ヘルプ",
    MissingLicense: "[ビルド ステータス] ウィンドウには、Simulink Coder および MATLAB Coder のライセンスが必要です。",
    ModelName: "モデル名",
    ModelStatusListNoBuildStatus: "表示する既存のビルド ステータスはありません。",
    NoExistingBuildStatus: "既存のビルド ステータスなし",
    NumActiveWorkers: "アクティブなワーカー数",
    OpenPAAct: "パフォーマンス\nアドバイザーを開く",
    OpenPAText: "*パフォーマンス アドバイザーを開くと詳細を確認できます",
    OptPoolSize: "最適なプール サイズ",
    Options: "オプション",
    OverallProgressText: "完了したモデル",
    Pending: "保留中",
    Scheduled: "スケジュール済み",
    SimTargets: "シミュレーション ターゲット",
    Status: "ステータス",
    WasUpToDate: "最新",
    invalidTargetType: "システム ターゲット タイプ '${0}' が無効です。ターゲット タイプは次のいずれかでなければなりません: { 'SIM'、'RTW' }。"
});
